import React from "react"
import IcoMoon from "react-icomoon"
const defaultIconSet = require("../../assets/icons/icomoon-menu-icons.json")

const resolveIconSet = (props) => {
	if (props.iconSet) return props.iconSet

	return defaultIconSet
}

const Icon = ({ ...props }) => {
	return <IcoMoon iconSet={resolveIconSet(props)} {...props} />
}

export default Icon
